<template>
</template>

<script>
  import Vue from 'vue'
  import {timeToISO8061} from '@/utils/cesiumUtils'

  export default {
    name: "clock",
    props: {
      cesiumObject: {
        type: String,
        default: 'default'
      },
      multiplier: {
        type: Number,
        default: 1
      },
      currentTime: {
        type: Number | Date,
        default: new Date().getTime()
      }
    },
    data() {
      return {
        prevTime: 0
      }
    },

    computed: {},

    methods: {
      initClock() {
        const viewer = this.getViewer();
        if (viewer === null) return;

        const clock = viewer.cesiumWidget.clock;

        clock.shouldAnimate = true;

        clock.onTick.addEventListener(this.clockTickHandler);
        this.updateMultiplier();
        this.updateStopTime();
        this.updateStartTime();
        this.updateCurrentTime();
      },
      getViewer() {
        return window.cesiumViewer[this.cesiumObject].viewer;
      },

      clockTickHandler(c) {
        const currentTime = Cesium.JulianDate.toDate(c.currentTime).getTime();

        if (Math.abs(this.prevTime - currentTime) < 500) return;

        this.prevTime = currentTime;

        this.$bus.$emit('clockTick', {
          currentTime,
          multiplier: this.getViewer().cesiumWidget.clock.multiplier
        })
      },

      updateMultiplier() {
        const viewer = this.getViewer();
        if (viewer !== null) viewer.cesiumWidget.clock.multiplier = this.multiplier;
      },
      updateStartTime() {
        const viewer = this.getViewer();
        const startTime = this.currentTime - 365 * 24 * 60 * 60 * 1000;
        if (viewer !== null) viewer.cesiumWidget.clock.startTime = Cesium.JulianDate.fromIso8601(timeToISO8061(startTime));
      },

      updateCurrentTime() {
        const viewer = this.getViewer();
        if (viewer !== null) viewer.cesiumWidget.clock.currentTime = Cesium.JulianDate.fromIso8601(timeToISO8061(this.currentTime));
      },

      updateStopTime() {
        const viewer = this.getViewer();
        const stopTime = this.currentTime + 365 * 24 * 60 * 60 * 1000;
        if (viewer !== null) viewer.cesiumWidget.clock.stopTime = Cesium.JulianDate.fromIso8601(timeToISO8061(stopTime));

      }
    },

    components: {},

    created() {
      this.initClock();
    },
    destroyed() {
      const clock = this.getViewer().cesiumWidget.clock;
      clock.onTick.removeEventListener(this.clockTickHandler);
    },

    watch: {
      multiplier() {
        this.updateMultiplier();
      },
      currentTime(newVal) {
        if(!newVal) return;
        this.updateCurrentTime();
        this.updateStartTime();
        this.updateStopTime();
      }
    }

  }
</script>

<style scoped>

</style>
